/**
 * Block days: the production calendar on a page of its own under Milk Flow (SC-2, Ronald on the decision sheet,
 * 19 October 2026). The cheese plan page is gone; the batches are Milk Flow's plan, and a block here caps them.
 */
import { PageHeader } from "@depicomnlbv/platform-ui";
import { Link } from "react-router-dom";

import { ProductionCalendarSection } from "../components/ProductionCalendar";
import { useTitle } from "../useTitle";
import "./milkFlow.css";

export function BlockDaysPage() {
  useTitle("Block days");
  return (
    <div className="page page--blocks mf-page">
      <PageHeader actions={<Link to="/milk-flow">Milk Flow</Link>} title="Block days" />
      <ProductionCalendarSection />
    </div>
  );
}
